import { TradeToEarnLeaderboardDto } from "@cede/types";

export const hasUserVolumeChanged = (
  hubUserId: number,
  previousLeaderboard: TradeToEarnLeaderboardDto,
  leaderboard: TradeToEarnLeaderboardDto,
) => {
  const previousUserPhaseVolume = previousLeaderboard.leaderboardRecords.find(
    (record) => record.hubUser.id === hubUserId,
  )?.volumeUSD;
  const newUserPhaseVolume = leaderboard.leaderboardRecords.find(
    (record) => record.hubUser.id === hubUserId,
  )?.volumeUSD;
  return previousUserPhaseVolume?.toString() !== newUserPhaseVolume?.toString();
};
